import { useNavigate } from 'react-router-dom';
import { SubscriptionHeader, SubscriptionContent, SubscriptionContainer } from '../../components/Subscriptions';

import styles from './MyCharityBanners.module.scss';
import BannersTable from './BannersTable';
import { PrimaryButton } from 'uiKit/atoms/Button/components/PrimaryButton';

interface MyCharityBannersProps {
  title: string;
}

const MyCharityBanners = ({ title }: MyCharityBannersProps) => {
  const navigate = useNavigate();

  const toNewBanner = () => navigate('/');

  return (
    <SubscriptionContainer>
      <SubscriptionHeader title={title}>
        <PrimaryButton variant="text" onClick={toNewBanner}>
          <div className={styles.bns3_mySubscriptionsButton}>
            <span>Add Banner</span>
          </div>
        </PrimaryButton>
      </SubscriptionHeader>
      <SubscriptionContent>
        <BannersTable />
      </SubscriptionContent>
    </SubscriptionContainer>
  );
};

MyCharityBanners.displayName = 'MyCharityBanners';

export default MyCharityBanners;
